"use client";

import { TabsList, TabsTrigger } from "@repo/ui/components/ui/tabs";
import type { LinkedItem } from "@repo/ui/types/cms/common";

interface InfoTabSwitcherProps {
  linkedItems?: LinkedItem[];
}

export const InfoTabSwitcher = ({ linkedItems }: InfoTabSwitcherProps) => {
  return (
    <TabsList className="w-full gap-2 px-3 py-6">
      {linkedItems?.length &&
        linkedItems.map((linkedItem) => (
          <TabsTrigger
            key={linkedItem.name}
            value={linkedItem?.name || ""}
            className="text-muted-foreground data-[state=active]:bg-brand-blue cursor-pointer py-4 text-base font-semibold data-[state=active]:text-white data-[state=inactive]:bg-[#E0E0E0]"
          >
            {linkedItem.name}
          </TabsTrigger>
        ))}
    </TabsList>
  );
};
